
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.081 14.115L2.594 15.13a.3.3 0 01-.469-.248V3a2 2 0 012-2h8.75a2 2 0 012 2v11.88a.3.3 0 01-.469.249l-1.487-1.014a.3.3 0 00-.338 0l-1.787 1.218a.3.3 0 01-.338 0l-1.787-1.218a.3.3 0 00-.338 0l-1.787 1.218a.3.3 0 01-.338 0L4.42 14.115a.3.3 0 00-.338 0z","stroke":"#7D1E36","stroke-width":"1.3","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M5 9h7M5 6h7","stroke":"#7D1E36","stroke-width":"1.3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    